import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authSession } from "@/lib/api";
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function Login() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Handle session_id from Emergent Auth callback
    if (window.location.hash?.includes("session_id=") && !hasProcessed.current) {
      hasProcessed.current = true;
      const hash = window.location.hash;
      const match = hash.match(/session_id=([^&]+)/);
      const session_id = match?.[1];
      if (session_id) {
        authSession(session_id)
          .then(() => {
            window.history.replaceState(null, "", "/admin");
            navigate("/admin", { replace: true });
          })
          .catch(err => {
            if (process.env.NODE_ENV !== "production") {
              // eslint-disable-next-line no-console
              console.error("Auth exchange failed:", err);
            }
          });
      }
    }
  }, [navigate]);

  const startLogin = () => {
    const redirectUrl = window.location.origin + "/admin/login";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-ccc-ivory flex items-center justify-center px-6" data-testid="login-page">
      <div className="w-full max-w-md bg-white border border-stone-200 p-10">
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto mb-4 bg-ccc-plum flex items-center justify-center">
            <svg viewBox="0 0 40 40" className="w-8 h-8 text-ccc-gold" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 4 L20 36 M12 20 L28 20" strokeLinecap="round"/>
              <path d="M6 30 L14 18 L20 24 L26 14 L34 30 Z" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="font-serif text-3xl text-ccc-plum">Advocacy CRM</div>
          <div className="text-sm text-stone-600 mt-1">Colorado Catholic Conference</div>
        </div>
        <button onClick={startLogin} data-testid="google-signin-btn"
          className="w-full bg-ccc-purple hover:bg-ccc-purple-dark text-white py-3 uppercase text-sm font-semibold tracking-wider transition-colors">
          Sign in with Google
        </button>
        <p className="text-xs text-stone-500 mt-6 text-center">
          Only authorized CCC staff can access the admin. Contact info@cocatholic.org for access.
        </p>
      </div>
    </div>
  );
}
